import { Suspense } from 'react';
import { SettingsNavMenu } from './SettingsNavMenu';
import { SettingsNavMenuStub } from './SettingsNavMenuStub';

export const SettingsNavMenuSuspense = () => (
    <Suspense fallback={<SettingsNavMenuStub />}>
        <SettingsNavMenu />
    </Suspense>
);
